import ExpandableCardList from './ExpandableCardList.component';

export default ExpandableCardList;
